// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1XeDV","right":"Footer_right__3W7ci","buttons":"Footer_buttons__2odMR"};